import React, {useState} from "react";
import { db } from "../firebase";
import {ref, set, update, push, child, } from 'firebase/database';
import Header from "../Components/Header/Header";
import { async } from "@firebase/util";


export default AddNewBin =>{
    const [newBinData, setNewBinData] = useState({
        ownerName: "",
        location: "",
        status: "",
        capacity: 0,
        company:"company1",
        lastUpdated: new Date().toLocaleString(),
        coOrdinates: {} 
      });


    // const handleGeocode = async () => {
    //     try{

    //         const apiKey = 'AIzaSyCw3F8YExAAliSXZzQoP_XjoKyCd_VL5gM';
    //         const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
    //           newBinData.location
    //         )}&key=${apiKey}`;
        
    //         const response = await fetch(apiUrl);
    //         const data = await response.json();
            
    //         if (data.results.length > 0) {
    //             const { lat, lng } = data.results[0].geometry.location;
    //             console.log(lat, lng)
    //             setNewBinData((prevData) => ({
    //             ...prevData,
    //             coOrdinates:{lat, lng}
    //             }))
    //             console.log(newBinData)
    //         } else {
    //             setNewBinData((prevData) => ({
    //                 ...prevData,
    //                 coOrdinates:{}
    //                 }))
    //         }
             
    //     }  catch (error) {
    //         console.error('Error geocoding:', error);
    //     }
    // }

    const handleChange = (event) => {
    const { name, value } = event.target;
    setNewBinData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        

        // const apiKey = 'AIzaSyCw3F8YExAAliSXZzQoP_XjoKyCd_VL5gM';
        const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
        const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
            newBinData.location
        )}&key=${apiKey}`;
    
        const response = await fetch(apiUrl);
        const data = await response.json();
        
        if (data.results.length > 0) {
            var { lat, lng } = data.results[0].geometry.location;
            console.log(lat, lng)
            
        } else {
            
            console.log('its the one working')
        }
             
        

        console.log(newBinData)
        const binId =await push(child(ref(db), 'bins')).key;
        const binData = {
            [binId]: {
                ownerName: newBinData.ownerName,
                location: newBinData.location,
                status: newBinData.status,
                capacity: newBinData.capacity,
                company:"company1",
                lastUpdated: newBinData.lastUpdated,
                coOrdinates: {latitude:lat, longitude:lng} 
            },
          };


        const newBinRef = await ref(db, 'bins/');
        await update(newBinRef, binData)
        .then(()=>{
            alert('bin is registered')
            // Clear the form
            setNewBinData({
                ownerName: '',
                location: '',
                status: '',
                capacity: 0,
                company: 'company1',
                lastUpdated: new Date().toLocaleString(),
                coOrdinates: {} 
          });
          
          console.log('success: data is submitted')
        })

    }

    
    return(
        <>
            <Header />
            <div class="flex  justify-center space-x-8 mt-14" >
                <div class=" w-1/4   bg-gray-800  border-gray-200 rounded-lg  sm:p-6 md:p-8 dark:bg-gray-800 dark:border-gray-700">
                    <form class="space-y-6" onSubmit={handleSubmit}>
                        <h3 class="text-xl font-medium text-white dark:text-white text-center">Add new Bin</h3>
        

                        <div>
                            <label for="ownerName"
                                class="block mb-2 text-sm font-medium text-white dark:text-white">Owner Name</label>
                            <input type="text" data-testid="owner-input" name="ownerName" id="ownerName" value={newBinData.ownerName} onChange={handleChange}
                                class="bg-gray-800 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-800 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                placeholder="Resident/ Org" required />
                        </div>

                        <div>
                            <label for="Location"
                                class="block mb-2 text-sm font-medium text-white dark:text-white">Location</label>
                            <input data-testid="location-input" type="text" name="location" id="location" value={newBinData.location} onChange={handleChange}
                                class="bg-gray-800 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-800 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                placeholder="House, nangi Mirpur AJK" required />
                        </div>

                        <div>
                            <label for="status"
                                class="block mb-2 text-sm font-medium text-white dark:text-white">Status</label>
                            <input type="text" data-testid="status-input" name="status" id="status" value={newBinData.status} onChange={handleChange}
                                class="bg-gray-800 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-800 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                placeholder="active/inactive" required />
                        </div>
        
                        <button type="submit"
                            class="w-full h-8 text-white bg-gray-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5  text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 ">Register Bin
                        </button>
        
                    </form>
                </div>
                <div class="">
                        <figure class = "">
                            <img src="images/bin.png" alt="bin" class="h-1/3 w-96 mt-10 text-white" />
                        </figure>
                </div>
                
            </div>
        </>
    )
}